<template>
  <div class="base">
    <inside-header title="提现记录" />
    <div class="list">
      <div v-for="(item, index) in promoter_withdrawal" :key="index" class="item">
        <div class="title">
          <span>提现-支付宝</span>
        </div>
        <div class="info clear">
          <div class="pull-left">
            <span class="" style="">{{ item.create_time | dayFormat }}</span>
            <span class="lode" style="">{{ item.create_time | minFormat }}</span>
          </div>
          <div class="pull-right">
            <span class="make" style="">-{{ item.amount }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { InsideHeader } from '@/components'
export default {
  name: 'TeacherWithdrawalRecord',
  components: {
    InsideHeader
  },
  filters: {
    dayFormat(val) {
      var stime = val * 1000
      var date = new Date(stime)
      //   var y = date.getFullYear()
      var m = date.getMonth() + 1
      var d = date.getDate()
      return m + '月' + d + '日'
    },
    minFormat(val) {
      var stime = val * 1000
      var date = new Date(stime)
      var h = date.getHours()
      var m = date.getMinutes()
      return h + ':' + m
    }
  },
  data() {
    return {
      promoter_withdrawal: []
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.$http({
        // url: 'index/teacher/withdrawalRecord',
        // method: 'get'
        url: 'index/promote/relevant',
        method: 'post'
      }).then(res => {
        console.log(res)
        if (res.status === 'success') {
          var data = res.data
          console.log(data)
          this.promoter_withdrawal = data.promoter_withdrawal
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>

  .list {
    padding: 15px;

    .item {
      padding: 10px 0px;
      border-bottom: 1px solid #eee;

      .title {
        font-family: PingFang-SC-Medium;
        font-size: 16px;
        line-height: 25px;
        color: #333333;
      }

      .info {
        .pull-left {
          font-family: PingFang-SC-Medium;
          font-size: 14px;
          line-height: 28px;
          color: #999999;
        }

        .pull-right {
          font-family: PingFang-SC-Bold;
          font-size: 16px;
          line-height: 28px;
          color: #333333;
          font-weight: bold;
        }
      }
    }
  }
</style>
